import { useContext } from 'react';

import { type ISidebarContextData, SidebarContext } from '../contexts/sidebar';

export const useSidebar = (): ISidebarContextData => useContext(SidebarContext);
